import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import {
	PublicClientApplication,
	EventType,
	EventMessage,
	AuthenticationResult,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { store } from "./app/store";
import { env } from "./env/env";
import "./index.css";
import "./i18n/i18n";

if (env.branch !== "main") {
	document.title = `[${env.branch}] Panda`;
} else {
	document.title = "Panda";
}

const msalInstance = new PublicClientApplication(msalConfig);

if (
	!msalInstance.getActiveAccount() &&
	msalInstance.getAllAccounts().length > 0
) {
	const accounts = msalInstance.getAllAccounts();
	if (accounts.length > 0) {
		msalInstance.setActiveAccount(accounts[0]);
	}
}

msalInstance.addEventCallback((event: EventMessage) => {
	if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
		const payload = event.payload as AuthenticationResult;
		const account = payload.account;
		msalInstance.setActiveAccount(account);
	}
});

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<Provider store={store}>
			<App instance={msalInstance} />
		</Provider>
	</React.StrictMode>,
);
